import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import Fuse from 'fuse.js';

import Date from 'types/date';
import toast from 'components/common/toast';
import confirmation from 'components/common/confirmation';
import Loader from 'components/common/loader';
import MainLayout from 'components/templates/main-layout';
import SideModal from 'components/common/side-modal';
import { TableContainer, Table, TableRow, TableCell, TableBody } from 'components/common/table';

import LocationsTable from './components/locations-table';
import EmptyLayout from './components/empty-layout';

import {
  GET_ENABLED_LOCATIONS,
  COMPARE_LOCATION_VERSIONS,
  CLOSE_STORAGE_REPORT,
  GET_LOCATION_VERSIONS,
  GET_INCIDENCES,
} from './requests';
import LoaderContainer from './elements';

const fuzzySearchOptions = {
  shouldSort: true,
  threshold: 0.1,
  location: 0,
  distance: 100,
  maxPatternLength: 64,
  minMatchCharLength: 3,
  keys: ['location.tag'],
};

class LocationCount extends Component {
  state = {
    locationSearch: '',
    loading: true,
    error: false,
    enabledLocations: [],
    locationsFiltered: [],
    loadingValidation: false,
    modalOpen: false,
    locationTag: '',
    loadingVersions: false,
    productsVersions: {},
  };

  componentDidMount = async () => {
    this.getEnabledLocations();
  };

  handleLocationSearch = event => {
    const { enabledLocations } = this.state;
    const {
      target: { value },
    } = event;

    const fuse = new Fuse(enabledLocations, fuzzySearchOptions);

    const locationsFiltered = fuse.search(value);

    this.setState({ locationSearch: value, locationsFiltered });
  };

  getEnabledLocations = async () => {
    const { client } = this.props;

    const { data, errors } = await client.query({
      query: GET_ENABLED_LOCATIONS,
    });

    if (errors) {
      toast.error('Algo salió mal, intentalo de nuevo');
      this.setState({ loading: false });
      return;
    }
	//SOPAS
	console.log(data);
    const { enabledLocations } = data;

    this.setState({ enabledLocations, loading: false });
  };

  compareLocationVersions = async tag => {
    const { client } = this.props;

    if (await confirmation('¿Estás seguro?')) {
      this.setState({ loadingValidation: true });
      const { data, errors } = await client.mutate({
        mutation: COMPARE_LOCATION_VERSIONS,
        variables: { tag },
      });

      if (errors) {
        const [error] = errors;

        if (error.includes('than 1 count')) {
          toast.info('Debe haber mas de un conteo para poder hacer una comparación');
        } else if (error.includes('it has the status SUCCESS')) {
          toast.info('Este conteo ya ha sido marcado como éxitoso');
        } else {
          toast.error('Algo salió mal, intentalo de nuevo');
        }

        this.setState({ loadingValidation: false });
        return;
      }

      const { compareLocationVersions } = data;

      if (compareLocationVersions === 'ERROR') {
        toast.error('Las versiones no coinciden');
      } else if (compareLocationVersions === 'SUCCESS') {
        toast.success('Comparación con éxito');
      }

      this.setState({ loadingValidation: false });
      this.getEnabledLocations();
    }
  };

  closeStorageReport = async () => {
    const { client } = this.props;

    if (await confirmation('¿Estás seguro?')) {
      this.setState({ loading: true });

      const { errors } = await client.mutate({
        mutation: CLOSE_STORAGE_REPORT,
      });

      if (errors) {
        const [error] = errors;

        if (error.includes('Unable to close report, all the locations need to have the status')) {
          toast.error('Para cerrar el reporte todas las ubicaciones deben ser EXITOSAS');
        } else {
          toast.error('Algo salió mal, intentalo de nuevo');
        }

        this.setState({ loading: false });
        return;
      }

      toast.success('Reporte cerrado con éxito');
      this.setState({ loading: false, enabledLocations: [] });
    }
  };

  setLocation = async tag => {
    this.setState({ locationTag: tag });
    this.toggleModal();
    await this.getLocationVersions(tag);
  };

  toggleModal = () => {
    const { modalOpen } = this.state;

    this.setState({ modalOpen: !modalOpen });
  };

  getLocationVersions = async tag => {
    const { client } = this.props;

    this.setState({ loadingVersions: true });

    const { data: getLocationVersionsData, errors: getLocationVersionsErrors } = await client.mutate({
      mutation: GET_LOCATION_VERSIONS,
      variables: { tag },
    });

    const { data: getIncidencesData, errors: getIncidencesErrors } = await client.query({
      query: GET_INCIDENCES,
      variables: { tag },
    });

    if (getLocationVersionsErrors || getIncidencesErrors) {
      toast.error('Algo salió mal, intentalo de nuevo');
      this.setState({ loadingVersions: false });
      return;
    }

    const { locationVersions } = getLocationVersionsData;
    const { incidences } = getIncidencesData;
    const products = {};

    for (let i = 0, len = locationVersions.length; i < len; i++) {
      const { user, id: versionId } = locationVersions[i];

      // eslint-disable-next-line no-loop-func
      locationVersions[i].products.forEach(product => {
        const { productCode, boxes, upc, totalPieces, batch, expiryDate, pieces } = product;

        if (!products[`${upc}${batch}${expiryDate}`]) {
          products[`${upc}${batch}${expiryDate}`] = {
            products: this.createArrayWithNullValues(locationVersions.length),
            isIncidence: false,
            productCode,
          }
        }

        if (!(products[`${upc}${batch}${expiryDate}`].isIncidence)) {
          products[`${upc}${batch}${expiryDate}`].isIncidence = !!(incidences.find(incidence => {
            return `${incidence.upc}${incidence.batch}${incidence.expiryDate}` 
              === `${upc}${batch}${expiryDate}`;
          }));
        }

        products[`${upc}${batch}${expiryDate}`].products[i] = {
          pieces: Number(totalPieces) - (Number(pieces) * Number(boxes)),
          user: user.name,
          boxes,
          productCode,
          totalPieces,
          batch,
          upc,
          versionId,
          expiryDate,
        };
      });
    }

    this.setState({ productsVersions: products, loadingVersions: false });
  };

  createArrayWithNullValues = (arrayLength) => {
    const newArray = [];

    for (let i = 0, len = arrayLength; i < len; i++) {
      newArray.push(null);
    }

    return newArray;
  }

  render() {
    const {
      locationSearch,
      enabledLocations,
      locationsFiltered,
      loading,
      loadingValidation,
      locationTag,
      modalOpen,
      loadingVersions,
      productsVersions,
    } = this.state;
    const { role } = this.props;

    const headers = Object.keys(productsVersions).map(key => key);
    const isEmpty = enabledLocations.length === 0;

    return (
      <MainLayout>
        <Fragment>
          {loading ? (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          ) : (
            <Fragment>
              {isEmpty && <EmptyLayout />}
              {!isEmpty && (
                <LocationsTable
                  handleInput={this.handleLocationSearch}
                  compareLocationVersions={this.compareLocationVersions}
                  closeStorageReport={this.closeStorageReport}
                  setLocation={this.setLocation}
                  value={locationSearch}
                  enabledLocations={enabledLocations}
                  locationsFiltered={locationsFiltered}
                  loadingValidation={loadingValidation}
                  role={role}
                />
              )}
            </Fragment>
          )}
        </Fragment>
        {modalOpen && (
          <SideModal
            title={`Versiones en ${locationTag} por código de productos`}
            closeButton={this.toggleModal}
          >
            {loadingVersions && (
              <LoaderContainer>
                <Loader />
              </LoaderContainer>
            )}
            {!loadingVersions && (
              <TableContainer>
                <Table>
                  <TableBody>
                    {headers.map((key, index) => (
                      <TableRow key={`${key}-${index}`}>
                        <TableCell header>{productsVersions[key].productCode}</TableCell>
                        {productsVersions[key].products.map((item, itemIndex) => {
                          if (item) {
                            const { user, createdAt, totalPieces, boxes, pieces, batch, upc, expiryDate } = item;

                            return (
                              <TableCell
                              backgroundColor={productsVersions[key].isIncidence ? 'danger' : 'gray'}
                              key={`${user}-${createdAt}-${itemIndex}`}
                              lineHeight="1.7"
                              >
                                Cajas: #{boxes} <br />
                                Piezas sueltas: #{pieces} <br />
                                Total de piezas: #{totalPieces} <br />
                                <br /> Lote: {batch} <br />
                                UPC: {upc} <br />
                                Fecha de caducidad: {new Date(expiryDate).format('ll')}<br />
                                Autor: {user}
                              </TableCell>
                            );
                          } else {
                            return (
                              <TableCell
                              backgroundColor={productsVersions[key].isIncidence ? 'danger' : 'gray'}
                              key={`null-${itemIndex}`}
                              lineHeight="1.7"
                              />
                            )
                          }
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </SideModal>
        )}
      </MainLayout>
    );
  }
}

export default withApollo(LocationCount);
